import React, { useContext } from 'react'

import { LocaleContext } from '../locale/i18n'

import ClientLogo, { IClientReference } from './ClientLogo'

import './ClientBar.scss'

const references: IClientReference[] = [
  {
    filename: 'kone.svg',
    title: 'Kone',
    url: 'https://kone.com/',
    width: 60,
  },
  {
    filename: 'neste.svg',
    title: 'Neste',
    url: 'https://www.neste.com/',
    width: 70,
  },
  {
    filename: 'fermion.svg',
    title: 'Fermion',
    url: 'https://www.fermion.fi/',
    width: 90,
  },
  {
    filename: 'planmeca.svg',
    title: 'Planmeca',
    url: 'https://www.planmeca.com/',
    width: 94,
  },
  {
    filename: 'sulapac.svg',
    title: 'Sulapac',
    url: 'https://www.sulapac.com/',
    width: 86,
  },
  {
    filename: 'okmetic.svg',
    title: 'Okmetic',
    url: 'https://www.okmetic.com/',
    width: 80,
  },
  {
    filename: 'luode.svg',
    title: 'Luode',
    url: 'https://www.luode.fi/',
    width: 79,
  },
]

const ClientBar = () => {
  const { t } = useContext(LocaleContext)
  return (
    <div className="clientBar">
      <div className="clientBar__logos">
        {references.map(logo => (
          <ClientLogo key={logo.title} {...logo} />
        ))}
      </div>
      <span className="clientBar__text">{t('home.hero.clientCount')}</span>
    </div>
  )
}

export default ClientBar
